import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'
// import saleRouter from './modules/sale'
// import systemRouter from './modules/system'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

export const globalRouter = [
  {
    path: '/',
    redirect: '/welcome',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        meta: {
          title: '首页',
          icon: 'home',
          affix: true
        },
        // component: () => import('@/components/HelloWorld')
        component: () => import('@/system/home')
      },
      {
        path: 'todo',
        name: 'Todo',
        meta: {
          title: '待办中心',
          keepAlive: true
        },
        // component: () => import('@/components/HelloWorld')
        component: () => import('@/system/todo')
      },
      {
        path: 'maintain',
        name: 'maintain',
        meta: {
          title: '维护中',
          // keepAlive: true
        },
        // component: () => import('@/components/HelloWorld')
        component: () => import('@/system/maintain')
      }
    ]
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/system/login')
  },
  // 角色选择
  {
    path: '/role',
    name: 'role',
    hidden: true,
    component: () => import('@/system/role')
  },
  // 移动端隐私协议
  {
    path: '/privacy-agreement',
    name: 'PrivacyAgreement',
    hidden: true,
    component: () => import('@/system/privacy-agreement')
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    component: () => import('@/views/noAuth')
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: globalRouter
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js